import { render, staticRenderFns } from "./avaliar-laudo-pessoa.vue?vue&type=template&id=3ee3a07a&"
import script from "./avaliar-laudo-pessoa.vue?vue&type=script&lang=ts&"
export * from "./avaliar-laudo-pessoa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee3a07a')) {
      api.createRecord('3ee3a07a', component.options)
    } else {
      api.reload('3ee3a07a', component.options)
    }
    module.hot.accept("./avaliar-laudo-pessoa.vue?vue&type=template&id=3ee3a07a&", function () {
      api.rerender('3ee3a07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/avaliar-laudo-pessoa.vue"
export default component.exports